import React from "react";
import AccordionSummary from "@mui/material/AccordionSummary";
import { ExpandMore } from "@mui/icons-material";
import Typography from "@mui/material/Typography";
import AccordionDetails from "@mui/material/AccordionDetails";
import Accordion from "@mui/material/Accordion";
import { SxProps, Theme } from "@mui/system";
import { Box } from "@mui/material";
import Link from "src/components/common/Links/Link";
import Image from "next/image";
import { ProductListBlocksSchema } from "src/models/newProduct/getNewProduct";

interface AnotherLinksListProps {
  title?: string;
  sx?: SxProps<Theme>;
  data: ProductListBlocksSchema[];
  image: string;
}

const AnotherLinksList: React.FC<AnotherLinksListProps> = ({
  sx,
  title,
  data,
  image,
}) => (
  <Accordion sx={sx}>
    <AccordionSummary expandIcon={<ExpandMore />}>
      <Image src={image} alt="иконка" width="25px" height="25px" />
      <Typography
        component="h3"
        fontWeight={500}
        color="primary"
        sx={{ ml: 1 }}
      >
        {title}
      </Typography>
    </AccordionSummary>
    <AccordionDetails sx={{ display: "flex", flexWrap: "wrap" }}>
      <Box
        sx={{
          display: "inline-block",
          width: "100%",
        }}
      >
        {data?.map((value, index, array) => (
          <Link
            href={value.slug}
            key={value.slug}
            sx={{
              textDecoration: "none",
              fontSize: "13px",
              cursor: "pointer",
              ":hover": {
                opacity: ".7",
                textDecoration: "underline",
              },
            }}
          >
            {index + 1 === array.length ? `${value.name}.` : `${value.name}, `}
          </Link>
        ))}
      </Box>
    </AccordionDetails>
  </Accordion>
);

export default AnotherLinksList;
